import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';

const SavedDataModal = ({ open, onClose, onYes, onNo }) => {
	return (
		<Modal open={open} onClose={onClose} size='tiny'>
			<Modal.Header>Saved Policy Change</Modal.Header>
			<Modal.Content>A previous policy change was saved.  Would you like to continue the change or discard the saved information?</Modal.Content>
			<Modal.Actions>
				<Button primary onClick={onYes}>
					Continue
				</Button>
				<Button primary onClick={onNo}>
					Discard
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

SavedDataModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onYes: PropTypes.func.isRequired,
	onNo: PropTypes.func.isRequired,
};

export default SavedDataModal;
